import styles from "./SocialIcon.module.css";
import * as SocialIcons from "../../Utility/SocialIcons/iconCricle";
import { useCustomClassContext } from "../../../hooks";
import cx from "classnames";

export type SocialIconProps = {
  target: string;
  icons: {
    name: string | keyof typeof SocialIcons;
    icon?: React.ReactElement;
    href?: string;
  }[];
  size?: number;
  fill?: string;
  //This will be the target page url to share
  pageToShare?: {
    url?: string;
    title?: string;
  };
};

export default function SocialIcon({
  target,
  icons,
  size = 44,
  fill,
  pageToShare,
}: SocialIconProps): React.ReactElement {
  const customClass = useCustomClassContext();
  //Retrieve shareable URL
  const shareableURL = (name: string, url?: string, title?: string) => {
    //Lets encode our url
    const encodedUrl = url && encodeURIComponent(url);
    //Lets define our list of brands
    const brands = {
      ["Facebook"]: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      ["Telegram"]: `https://t.me/share/url?url=${encodedUrl}`,
      ["X"]: `https://x.com/intent/tweet?url=${encodedUrl}`,
      ["Whatsapp"]: `https://api.whatsapp.com/send?text=${encodedUrl}`,
      ["LinkedIn"]: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      ["Email"]: `mailto://?subject=${encodeURIComponent(title || "")}&body=${encodedUrl}`,
      ["Pinterest"]: `http://pinterest.com/pin/create/button/?url=${encodedUrl}`,
    };

    return (name in brands && brands[name as keyof typeof brands]) || undefined;
  };

  return (
    <div className={styles.socialIconsContainer}>
      {icons.map(({ icon, name, href }, id: number) => {
        const AutoIcon =
          name in SocialIcons && SocialIcons[name as keyof typeof SocialIcons];

        // Now, lets determine our target URL. First, check if pageUrl is not empty and if
        // not then get the socialMedia url using the name as KEY and append the
        // encoded pageUrl. Otherwise, return whatever value from ${href}.
        const targetUrl = pageToShare
          ? shareableURL(name, pageToShare.url, pageToShare.title)
          : href;

        const dataLayoutPosition = pageToShare
          ? "socialshareicon"
          : "socialicon";

        if (name === "Copy") {
          return (
            <button
              key={id}
              type="button"
              data-layout-position={dataLayoutPosition}
              className={styles.socialIconsContainerItem}
              onClick={() => {
                if (pageToShare?.url) {
                  navigator.clipboard.writeText(pageToShare.url);
                }
              }}
            >
              {icon || "Copy"}
            </button>
          );
        }

        return (
          <a
            key={id}
            href={targetUrl}
            target={target}
            data-layout-position={dataLayoutPosition}
            className={cx(
              styles.socialIconsContainerItem,
              customClass?.socialIcons?.socialMedialink,
            )}
          >
            {icon ||
              (AutoIcon && (
                <AutoIcon width={`${size}`} height={`${size}`} fill={fill} />
              ))}
          </a>
        );
      })}
    </div>
  );
}
